<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="cashaccountsModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Pettycash</small>
              </legend>
              <form @submit.prevent="loadCashAccount()">
                <div class="row">
                  <input type="hidden" class="pettyaccount_id" :value="Pettyaccount.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingCashAccount">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingCashAccountLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage petty accounts</small>
      </legend>
      <div>
        <div class="pettyaccountsLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading pettyaccounts...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemPettyaccounts"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#cashaccountsModal"
                @click="viewCashAccount(props.row.id)"
              >
                <i class="fa fa-file-pdf-o"></i> Cash account
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Petty acount",
          field: "pettyaccounts_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by petty account"
          }
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
         {
          label: "Action",
          field: "Action",
          width: "122px",
          type: "text"
        }
      ]
    };
  },
  created() {
    this.loadPettyaccounts();
  },
  computed: {
    ...mapGetters(["systemPettyaccounts", "Pettyaccount"])
  },
  methods: {
    ...mapActions(["loadPettyaccounts", "viewCashAccount", "loadCashAccount"])
  }
};
</script>
<style scoped>
.creatingCashAccountLoader {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/cashaccount.vue